function sumLists(arrays: number[][]): number[] {
  return arrays.reduce((acc, array) => acc.map((sum, i) => sum + array[i]), new Array(arrays[0].length).fill(0));
}

export default sumLists;
